import React from 'react';
import { message, Select } from "antd"
import { state, setState } from "@/store"
import moment from "moment"
import { getUrlParam } from "@/utils";
import { BaseService, WXService } from "@/service";

const { Option } = Select;

export const checkResult = (result, remind = true) => {
    const boo = result && result.data.status === 200;
    if (!boo && remind && result.msg) message.error(result.msg);
    return boo;
};
export const createSelectOption = (datas = [], lang = "zh", enName = "en") => datas.map((item) => {
    const { label, value } = item;
    return <Option key={value} data={item} value={value}>{lang === "zh" ? label : item[enName]}</Option>
})
export const carouselAutoPlay = (target, interval = 5000) => {
    let timer = setInterval(() => {
        try {
            if (target) target.next();
            else {
                clearInterval(timer);
                timer = null;
            }
        } catch (error) {
            clearInterval(timer);
            timer = null;
        }
    }, interval)
}
export const to = (IS_LOGIN, path) => {
    if (!IS_LOGIN) {
        const back = window.location.hash.slice(1);
        if (state.loginBack !== back) setState("loginBack", back);
    }
    return IS_LOGIN ? path : "/login"
};
export const avatar = (url = "", host) => {
    if (!url) return state.defaultHead;
    if (/^(http|https):\/\//.test(url)) return url;
    else return `http://${host}${url}`
}
export const createFilePath = (url = "", host = "211.149.135.84:8084") => {
    if (!url) return "";
    if (!host) host = "211.149.135.84:8084"
    if (/^(http|https):\/\//.test(url)) return url;
    else return `http://${host}${url}`
}
export const second2Date = time => new Date(time * 1000).format("yyyy-MM-dd");
export const second2DateTime = time => new Date(time * 1000).format("yyyy-MM-dd hh:mm:ss");
export const CheckWXUser = () => {

    if (state.wxUser.user_id) return;

    const setWXUser = value => setState("wxUser", value);

    const wx_code = getUrlParam("code");

    // 查询用户
    const getUser = openid => {
        BaseService.list({
            table: "thtt_user",
            columns: "user_id",
            where: { openid: openid, is_delete: 0 }
        }).then(res => {
            if (!checkResult(res)) return;
            state.wxUser.user_id = res.data.result.length && res.data.result[0].user_id || "";
            setWXUser({ ...state.wxUser });
        })
    }

    if (wx_code) WXService.webOauth2({ code: wx_code }).then(res => {
        setWXUser(res.data);
        getUser(res.data.openid);
    }, err => message.error("webOauth2 Error", err))
}
export const setWXShare = ({ title, desc, imgUrl = "http://ww2.techchina.org.cn/assets/logo.png", link = encodeURI(window.location.href) }) => {
    const wx = window.wx;
    wx.updateAppMessageShareData({ title, desc, link, imgUrl });
    wx.updateTimelineShareData({ title, desc, link, imgUrl });
    wx.onMenuShareAppMessage({ title, desc, link, imgUrl, type: "link" });
    wx.onMenuShareTimeline({ title, desc, link, imgUrl });
}

export const loadRegions = async selectedOptions => {
    const targetOption = selectedOptions[selectedOptions.length - 1];
    targetOption.loading = true;

    const childs = await BaseService.list({
        table: "thtt_china",
        columns: "id,name,level",
        where: { pid: targetOption.value }
    })

    targetOption.loading = false;
    targetOption.children = childs.data.result.map(({ id, name, level }) => ({ label: name, value: id, isLeaf: level === 3 }))
    setState("$_REGIONS", state.$_REGIONS);
}
// 禁止选择当天以后等日期
export const disabledLastDate = (current) => current && current > moment().endOf('day');
export const goTop = el => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
}